import React, { useEffect, useState, useRef } from "react";
import { Button, Input, Modal, message, Table, Typography, Alert } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../locale";
import ProtocolServices from "../../services/ProtocolServices";
import SectionLoader from "../Loaders/SectionLoader";

const { Search } = Input;

const { Title } = Typography;

const AddProtocolSubscription = ({
  subscription,
  visible,
  onComplete,
  onCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (value, record, index) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => {
              handleConnectProtocol(record);
            }}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Nombre"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: translate("Duración (Días)"),
      dataIndex: "duration",
      key: "duration",
    },
  ];

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        loadData();
      }
    }
  }, [visible]);

  const loadData = async (search = "") => {
    setLoading(true);
    try {
      const response = await ProtocolServices.searchProtocols(
        subscription.id,
        subscription.enterprise.id,
        search
      );
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.protocols);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const onSearch = (value) => {
    loadData(value);
  };

  const resetForm = () => {
    setError("");
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleConnectProtocol = async (data) => {
    setSaving(true);
    setError("");
    try {
      const response = await ProtocolServices.updateProtocol({
        protocol_id: data.id,
        subscriptions: [subscription.id],
      });
      if (response.status >= 200 && response.status < 300) {
        if (onComplete) {
          onComplete();
        }
        message.success(
          translate("El {0} se guardó exitosamente.", translate("protocolo"))
        );
        resetForm();
      } else {
        setError(
          translate("No se pudo conectar el {0}.", translate("protocolo"))
        );
      }
      setSaving(false);
    } catch (e) {
      console.log(e);
      setSaving(false);
      setError(
        translate("No se pudo conectar el {0}.", translate("protocolo"))
      );
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Conectar {0}", translate("protocolo"))}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
      width="80%"
    >
      <Title level={4}>{translate("Buscar {0}", translate("protocolo"))}</Title>

      <Search
        placeholder={translate("Nombre de {0}", translate("protocolo"))}
        allowClear
        size="large"
        name="name"
        onSearch={onSearch}
        loading={loading}
        className="max-w-sm mb-6"
        enterButton={translate("Buscar")}
      />

      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}

      <Table
        dataSource={data}
        columns={columns}
        rowKey={(i) => i.id}
        loading={loading}
      />
      {saving && <SectionLoader />}
    </Modal>
  );
};

export default AddProtocolSubscription;
